var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.no_title)?_c('standart-card',{staticClass:"relative",attrs:{"title":_vm.name,"height":"375px"}},[_c('div',[_c('line-chart',{attrs:{"styles":_vm.styles,"chart-data":_vm.datacollection,"options":{
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            fontColor: '#ffffff'
          }
        },
        animation: false,
        parsing: false
      }}})],1)]):_c('div',[_c('line-chart',{attrs:{"styles":_vm.styles,"chart-data":_vm.datacollection,"options":{
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        labels: {
          fontColor: '#ffffff'
        }
      },
      animation: false,
      parsing: false
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }